module.exports = {
  ...require('./_billings'),
  ...require('./_communications'),
  ...require('./_contactLists'),
  ...require('./_contacts'),
  ...require('./_dictionaries'),
  ...require('./_documentTemplates'),
  ...require('./_eventsHistory'),
  ...require('./_globalBlacklistManager'),
  ...require('./_notifications'),
  ...require('./_paymentLogs'),
  ...require('./_payments'),
  ...require('./_providerGroups'),
  ...require('./_providerPrices'),
  ...require('./_providers'),
  ...require('./_recurrentPayments'),
  ...require('./_reports'),
  ...require('./_requisites'),
  ...require('./_routingGroups'),
  ...require('./_messageRuleGroups'),
  ...require('./_messageRules'),
  ...require('./_routingRules'),
  ...require('./_sendernames'),
  ...require('./_sendings'),
  ...require('./_sendingsFallbacks'),
  ...require('./_sendingsModeration'),
  ...require('./_servers'),
  ...require('./_settings'),
  ...require('./_storage'),
  ...require('./_tariffs'),
  ...require('./_tasks'),
  ...require('./_telemetry'),
  ...require('./_tts'),
  ...require('./_users'),

  ...require('./empty'),
  ...require('./misc'),
  ...require('./operatorGroups'),
  ...require('./presets'),
  ...require('./regexp'),
  ...require('./mimeTypes')
}
